import { render, staticRenderFns } from "./BelgeListe.vue?vue&type=template&id=3ecf7b5a&"
import script from "./BelgeListe.vue?vue&type=script&lang=js&"
export * from "./BelgeListe.vue?vue&type=script&lang=js&"
import style0 from "./BelgeListe.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BelgeListe.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports